module.exports = __webpack_public_path__ + "img/loading.7096b355.gif";